module.exports = {"TXTMOB_Resend_code_in_N0":{"id":"TXTMOB_Resend_code_in_N0","defaultMessage":"{0} 後にコードを再送信","track":"Resend code in {0}"}}